export default "__VITE_ASSET__4627a92b__"